import React, { useEffect, useState } from "react";
import ManagerStatementService from "../../../../../services/managerStatement.service";
import { CommissionPayoutInvoice, TransactionListItem } from "../../../../../interfaces/managerStatement.interface";
import { CLEANING_MARGIN_PERCENTAGE } from "../../../../../utils/appConstant";
import StatementKpiSummary from "./StatementKpiSummary";

interface DocumentsKpiSummaryProps {
  statementId: string;
}

const DocumentsKpiSummary: React.FC<DocumentsKpiSummaryProps> = ({ statementId }) => {
  const [commissionTotal, setCommissionTotal] = useState(0);
  const [cleaningTotal, setCleaningTotal] = useState(0);
  const [transactionsTotal, setTransactionsTotal] = useState(0);

  useEffect(() => {
    if (!statementId) return;

    ManagerStatementService.get(statementId)
      .then((response: any) => {
        setCleaningTotal(Number(response?.cleaning_split_amount || 0) * (CLEANING_MARGIN_PERCENTAGE / 100));
      })
      .catch(() => {
        setCleaningTotal(0);
      });

    ManagerStatementService.getCommissionPayouts(statementId)
      .then((response: any) => {
        const rows: CommissionPayoutInvoice[] = response?.invoices ?? [];
        const total = rows
          .filter((row) => row.selected)
          .reduce((acc, row) => acc + Number(row.commission_earned || 0), 0);
        setCommissionTotal(total);
      })
      .catch(() => {
        setCommissionTotal(0);
      });

    ManagerStatementService.getTransactions(statementId)
      .then((response: any) => {
        const rows: TransactionListItem[] = response?.transactions ?? [];
        const total = rows
          .filter((row) => row.rule_defined && row.selected)
          .reduce((acc, row) => acc + Number(row.paid_to_manager || 0), 0);
        setTransactionsTotal(total);
      })
      .catch(() => {
        setTransactionsTotal(0);
      });
  }, [statementId]);

  return <StatementKpiSummary commissionTotal={commissionTotal} cleaningTotal={cleaningTotal} transactionsTotal={transactionsTotal} />;
};

export default DocumentsKpiSummary;
